import { render } from "./Subscribe.vue?vue&type=template&id=00ee38c8"
import script from "./Subscribe.vue?vue&type=script&lang=js"
export * from "./Subscribe.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/Pages/Subscribe.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00ee38c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00ee38c8', __exports__)) {
    api.reload('00ee38c8', __exports__)
  }
  
  module.hot.accept("./Subscribe.vue?vue&type=template&id=00ee38c8", () => {
    api.rerender('00ee38c8', render)
  })

}


export default __exports__